"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toQuoteSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var QUOTE_DISPLAY_STYLE_PRISMIC_TO_LGLP = {
    'Par défaut': types_1.QuoteDisplayStyle.DEFAULT,
    'dans une bulle': types_1.QuoteDisplayStyle.BUBBLE
};
var toQuoteSlice = function (data, logger) {
    var _a, _b;
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.Quote)), { text: logger.required(fields_1.toRichText((_a = data === null || data === void 0 ? void 0 : data.primary) === null || _a === void 0 ? void 0 : _a.text, logger)), displayStyle: logger.toConstValue((_b = data === null || data === void 0 ? void 0 : data.primary) === null || _b === void 0 ? void 0 : _b.displayStyle, QUOTE_DISPLAY_STYLE_PRISMIC_TO_LGLP) }));
};
exports.toQuoteSlice = toQuoteSlice;
//# sourceMappingURL=quote-slice.js.map